import React from 'react';

export const PublicIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <g fill="none" fillRule="evenodd">
        <path stroke="#B9C4E3" strokeWidth="2" d="M3 5h18v15H3z" />
        <path fill="#4560B0" d="M3 3h18a1 1 0 0 1 1 1v2H2V4a1 1 0 0 1 1-1z" />
        <path fill="#B9C4E3" d="M11 8h7v2h-7zm0 3h7v2h-7z" />
        <path fill="#4560B0" d="M6 8h4v2H6zm0 2h4v3H6z" />
        <path fill="#B9C4E3" d="M11 15h7v2h-7z" />
        <path fill="#4560B0" d="M6 15h4v2H6z" />
      </g>
    </svg>
  );
};

export const MemberOnlyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#B9C4E3"
        d="M14 16h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5.753H3.247a1 1 0 0 1-.977-1.217L3 17.5A5.747 5.747 0 0 1 8.61 13h4.78c.355 0 .703.032 1.042.095-.273.4-.432.884-.432 1.405V16z"
      />
      <path
        stroke="#4560B0"
        strokeWidth="1.2"
        d="M16.5 12a2.5 2.5 0 0 1 2.5 2.5V17h-5v-2.5a2.5 2.5 0 0 1 2.5-2.5z"
      />
      <path
        fill="#4560B0"
        d="M13 16h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm3.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.5-.5z"
      />
      <circle cx="11" cy="7" r="4" stroke="#B9C4E3" strokeLinejoin="round" strokeWidth="2" />
    </g>
  </svg>
);

export const CMEIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path fill="#4560B0" d="M4.5 6.5h3v14h-3z" />
      <path
        stroke="#B9C4E3"
        strokeLinecap="square"
        strokeWidth="2"
        d="M20 7.708V21H6.5C5.12 21 4 19.845 4 18.42V5v2.58"
      />
      <path stroke="#B9C4E3" strokeLinecap="square" strokeWidth="2" d="M20 7H6a2 2 0 1 1 0-4h14" />
      <path fill="#4560B0" d="M10.5 13h6v2h-6z" />
      <path fill="#4560B0" d="M14.5 11v6h-2v-6z" />
    </g>
  </svg>
);

export const EPharmIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#B9C4E3"
        strokeWidth="2"
        d="M10.544 8.299l3.224-3.224a4 4 0 1 1 5.657 5.657l-7.071 7.071a4 4 0 1 1-5.657-5.657L10.544 8.3z"
      />
      <path fill="#4560B0" d="M8.818 8.61l7.071 7.072-4.243 4.243a5 5 0 0 1-7.07-7.071L8.817 8.61z" />
      <path stroke="#B9C4E3" strokeWidth="2" d="M5.99 18.51a3 3 0 0 1 0-4.242" />
    </g>
  </svg>
);

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="#9B9B9B"
      d="M10.752 11.936L4.825 6.009a.909.909 0 0 1-.013-1.286.909.909 0 0 1 1.286.013l5.927 5.927 5.927-5.927a.909.909 0 0 1 1.285-.013.909.909 0 0 1-.012 1.286l-5.927 5.927 5.927 5.927a.909.909 0 0 1 .012 1.285.909.909 0 0 1-1.285-.012l-5.927-5.927-5.927 5.927a.909.909 0 0 1-1.286.012.909.909 0 0 1 .013-1.285l5.927-5.927z"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="#9B9B9B"
      d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
    />
  </svg>
);

export const ApplyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#B9C4E3"
        d="M9.743 13h6.938a.432.432 0 0 1 .319.723c-.279.305-1.037 1.236-2.274 2.793a1 1 0 0 0-.124 1.043L15.734 20l1.862 2H3.387a1 1 0 0 1-.948-1.316L3.5 17.5A6.581 6.581 0 0 1 9.743 13z"
      />
      <path
        fill="#4560B0"
        d="M17 17h-2v1h2v2h1v-2h2v-1h-2v-2h-1v2zm.5 5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"
      />
      <circle cx="12" cy="7" r="4" stroke="#B9C4E3" strokeLinejoin="round" strokeWidth="2" />
    </g>
  </svg>
);

export const LoginIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <g transform="rotate(135 10.246 8.33)">
        <path stroke="#4560B0" strokeLinejoin="round" strokeWidth="1.5" d="M14.418 4.55H3.607" />
        <path stroke="#4560B0" strokeWidth="1.5" d="M10.17.257L14.414 4.5l-4.242 4.243" />
        <circle cx="2.5" cy="4.55" r="2.5" fill="#4560B0" />
      </g>
      <path stroke="#B9C4E3" strokeWidth="2" d="M11.885 3.678a8.5 8.5 0 0 0 0 17 8.5 8.5 0 0 0 8.5-8.5" />
    </g>
  </svg>
);

export const MemberCardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path fill="#4560B0" d="M3 3h6v6H3V3zm2 2v2h2V5H5z" />
      <path fill="#B9C4E3" d="M3 15h6v6H3v-6zm2 2v2h2v-2H5z" />
      <path fill="#4560B0" d="M15 15h6v6h-6v-6zm2 2v2h2v-2h-2z" />
      <path
        fill="#B9C4E3"
        d="M15 3h6v6h-6V3zm2 2v2h2V5h-2zM3 11h2v2H3zm6-4h2v2H9zm4 10h2v2h-2zm-6-6h4v2H7zm10 0h4v2h-4zm-8 2h8v2H9zm2-10h2v4h-2zm0 14h2v4h-2zm0-8h4v2h-4z"
      />
    </g>
  </svg>
);

export const AccountIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#B9C4E3"
        d="M9.743 13h4.514a6.581 6.581 0 0 1 6.243 4.5l1.061 3.184A1 1 0 0 1 20.613 22H3.387a1 1 0 0 1-.948-1.316L3.5 17.5A6.581 6.581 0 0 1 9.743 13z"
      />
      <circle cx="12" cy="7" r="4" stroke="#B9C4E3" strokeLinejoin="round" strokeWidth="2" />
    </g>
  </svg>
);

export const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd" transform="rotate(-45 11.096 13.081)">
      <path stroke="#4560B0" strokeLinejoin="round" strokeWidth="1.5" d="M24.932 13h-10.81" />
      <path stroke="#4560B0" strokeWidth="1.5" d="M19.978 8l4.95 4.95-4.95 4.95" />
      <path
        stroke="#B9C4E3"
        strokeWidth="2"
        d="M18.303 6.99a8.5 8.5 0 0 0-12.02 12.02 8.5 8.5 0 0 0 12.02 0"
      />
      <circle cx="13.015" cy="13" r="2.5" fill="#4560B0" />
    </g>
  </svg>
);
